import { IdPs } from '../constants/providers';

export const signoutUrlMap = new Map<IdPs, string>([
  [
    IdPs.LoginWithAmazon,
    'https://www.amazon.com/gp/help/customer/display.html?nodeId=GQL359FK7DM8294C',
  ],
  [IdPs.AWSBuilderID, 'https://profile.aws.amazon.com/'],
]);
